import { useEffect, useRef } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useSelector } from 'react-redux';
import { recordarDestino, rutaDe } from '../../utils/destinoAlEntrar';

const PrivateRoute = () => { 
  const auth = useSelector(state => state.auth);
  const location = useLocation();
  const ruta = rutaDe(location);

  // Quien llega sin sesión (un enlace de un correo, un marcador) regresa a esta pantalla al entrar. Si la sesión se cierra estando
  // aquí no se recuerda: al salir se va al inicio, y la sesión vencida ya la recordó backendAxios.
  const llegoConSesion = useRef(Boolean(auth.token));
  useEffect(() => {
    if (!auth.token && !llegoConSesion.current) recordarDestino(ruta);
  }, [auth.token, ruta]);

  // `replace`: la pantalla privada no se queda en el historial; si no, «atrás» desde el login volvería a mandar al login
  return auth.token ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;